<scitis-breadcrumb [breadcrumbRoutes]="routes"></scitis-breadcrumb>
<scitis-app-global-page-header>
  <div header-title>
    <scitis-page-header-logo-and-name
        [machineCategory]="pageGlobalParameters.machineCategory"
        [machineId]="pageGlobalParameters.machineId"
        [machineMenuItem]="pageGlobalParameters.associatedMenuItem.menuItemParent"
        [pageName]="pageGlobalParameters.pageName"
        [pageType]="pageGlobalParameters.pageType">

    </scitis-page-header-logo-and-name>
  </div>


  <ng-template #filterElement>
    <button (click)="onAddWidgetEvent()" *ngIf="isUserPageInEditMode && !isDistributorOrViewerRole"
            class="btn btn-primary">
      <span class="fa-solid fa-plus"></span>
      <span translate>Add widget</span>
    </button>
  </ng-template>

  <ng-template #filterElement>
    <button (click)="onSavePage()" *ngIf="isUserPageInEditMode && !isDistributorOrViewerRole"
            class="btn btn-primary">
      <span class="fa-solid fa-check"></span>
      <span translate>Save</span>
    </button>
  </ng-template>

  <ng-template #filterElement *ngIf="isUserPageInEditMode && !isDistributorOrViewerRole">
    <div class="divider"></div>
  </ng-template>


  <ng-template #filterElement>

    <button (click)="onEditLayoutChangeEvent()"
            [disabled]="isDisabledEditButton"
            [ngClass]="{ 'btn-primary' :!isUserPageInEditMode, 'btn-outline-primary': isUserPageInEditMode}"
            class="btn btn-primary">
      <span class="fa-solid fa-pen"></span>
      <span *ngIf="!isUserPageInEditMode" translate>Edit Layout</span>
      <span *ngIf="isUserPageInEditMode" translate>Stop Editing</span>
    </button>
  </ng-template>

  <ng-template #filterElement>
    <div #myDrop="ngbDropdown" ngbDropdown>
      <button (focus)="myDrop.open()" class="btn btn-outline-primary" id="dropdownManual" ngbDropdownAnchor>
        <span translate>Functions</span>
      </button>
      <div aria-labelledby="dropdownManual" ngbDropdownMenu>
        <button (click)="onPageDuplicateEvent()" [disabled]="isDistributorOrViewerRole" ngbDropdownItem>
          <span *ngIf="isTemplatePage" class="fa-solid fa-right-left"></span>
          <span *ngIf="isTemplatePage" translate>Copy as user defined page</span>

          <span *ngIf="!isTemplatePage" class="fa-solid fa-clone"></span>
          <span *ngIf="!isTemplatePage" translate>Duplicate</span>
        </button>

        <div *ngIf="isTemplatePage" class="dropdown-menu-footer">
          <div class="custom-control custom-switch">
            <input #syncTemplate (change)="onSyncTemplatePage()" [disabled]="isLoading || isAdminOrLower"
                   [checked]="syncTemplatePage"
                   class="custom-control-input"
                   id="syncTemplatePage"
                   type="checkbox">
            <label class="custom-control-label" for="syncTemplatePage" translate>Enable Template Synchronization</label>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</scitis-app-global-page-header>

<!-- Loading container -->
<div *ngIf="isLoading"
     class="page-content page-content-full card content-loading d-flex align-items-center justify-content-center">
  <div class="text-center">
    <div class="mb-2 display-4 text-primary">
      <span class="fa-solid fa-spinner fa-spin"></span>
    </div>
    <p>
      <strong translate>Loading widgets</strong><br>
      <span translate>Please wait ...</span>
    </p>
  </div>
</div>

<div *ngIf="!isLoading">
  <div
      *ngIf="!liveDataStreamingEnabled && !displayEmptyStateFallback"
      class="alert alert-info text-center">
    <span translate>Live data streaming is disabled. No data is polled.</span>
  </div>
  <scitis-empty-state-fallback *ngIf="displayEmptyStateFallback" [fallBackMessage]="fallBackMessage">
  </scitis-empty-state-fallback>
  <div class="page-content">
    <scitis-grid-container
        (deleteWidget)="onRemoveWidget($event)"
        (moveToInteractiveDataAnalysisEvent)="onMoveToInteractiveDataAnalysis($event)"
        (newWidget)="onNewWidget($event)"
        (updatedLayout)="onLayoutUpdate($event)"
        [isInEditMode]="isUserPageInEditMode"
        [isOnTemplatePage]="isTemplatePage"
        [machine]="machine"
        [firebaseUserId]="pageGlobalParameters.firebaseUserId"
        [menuItem]="pageGlobalParameters.associatedMenuItem"
        [shouldAddWidget]="userPageAddWidget"
        [widgets]="widgets">
    </scitis-grid-container>
  </div>
</div>
